import { SnackbarProvider } from 'notistack'
import { useEffect, useState } from 'react'
import Loadable from 'react-loadable'
import { connect } from 'react-redux'
import { setLanguage, setTranslations } from 'redux-i18n'
import Loader from '../components/parts/loader/loader'
import { translations } from '../locale/translations'
import { userLogout, userMe } from '../store/actions/auth'
import { defaultFontSize, updateFontSize } from '../store/actions/fontSize'
import ErrorBoundary from './errorBoundary'

// Material UI
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'

// Styled components
import { ThemeProvider } from 'styled-components'
import { Container, GlobalStyles } from './styled'

// Assets
import { ReactComponent as Close } from '../images/icons/close.svg'

// Themes
import { Theme } from '../components/theme/'

function Loading({ error }) {
	if (error) return error
	else return <Loader />
}

//import Routes from '../routes'
const Routes = Loadable({ loader: () => import('../routes'), loading: Loading })

const App = props => {
	const {
		auth,
		newTranslate,
		authRequest,
		changeLanguage,
		storeFS,
		setFontSize,
		setDefault,
	} = props
	const [lsTheme, setLsTheme] = useState(localStorage.getItem('theme'))
	const localFS = localStorage.getItem('prefferedFontSize')
	useEffect(() => {
		authRequest()
		Object.keys(translations).map(x => newTranslate(translations[x], x))
		changeLanguage(!auth ? 'pt-BR' : auth.language)
	}, [])

	useEffect(() => {
		if (auth && auth.theme) {
			localStorage.setItem('theme', auth.theme)
			setLsTheme(auth.theme)
		}
	}, [auth])

	if (storeFS !== '' && storeFS !== localFS)
		localStorage.setItem('prefferedFontSize', storeFS)

	if (storeFS === '') setFontSize(localFS || setDefault())

	document.body.parentElement.style.fontSize = `${storeFS}%`

	const handleTheme = () => {
		if (
			!auth ||
			auth.type === 'USER_ERROR' ||
			lsTheme === 'light' ||
			lsTheme === null
		)
			return Theme.light
		return Object.keys(Theme).filter(key => auth.theme === key)[0]
			? Theme[Object.keys(Theme).filter(key => auth.theme === key)[0]]
			: Theme.light
	}

	return (
		<ThemeProvider theme={handleTheme()}>
			<Container>
				<GlobalStyles />
				<ErrorBoundary>
					<SnackbarProvider
						anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
						autoHideDuration={10000}
						className={'snackbar'}
						action={[
							<IconButton key="fechar" aria-label="Fechar">
								<Close />
							</IconButton>,
						]}
						maxSnack={3}
					>
						<MuiThemeProvider
							theme={createMuiTheme({
								overrides: {
									/* MuiSwitch: {
																		root: {
																				width: 28,
																				height: 16,
																				padding: 0,
																				display: 'flex',
																			},
																			switchBase: {
																				padding: 2,
																				color: '#cecece',
																				'&$checked': {
																					transform: 'translateX(12px)',
																					color: '#fff',
																					'& + $track': {
																						opacity: 1,
																						backgroundColor: '#7D3CE8',
																						borderColor: '#7D3CE8',
																					},
																				},
																			},
																			thumb: {
																				width: 12,
																				height: 12,
																				boxShadow: 'none',
																			},
																			track: {
																				border: `1px solid #cecece`,
																				borderRadius: 16 / 2,
																				opacity: 1,
																				backgroundColor: '#fff',
																			},
																			checked: {},

																}, */
									MuiOutlinedInput: {
										input: {
											padding: '9px 15px',
										},
									},
									MuiButtonBase: {
										root: {
											padding: '9px 15px',
										},
									},
									MuiButton: {
										label: {
											textTransform: 'none',
										},
									},
									MuiSkeleton: {
										text: {
											marginTop: 0,
											marginBottom: 0,
											borderRadius: 0,
										},
									},
									MuiChip: {
										root: {
											borderRadius: '3px',
										},
									},
								},
								palette: {
									primary: { main: handleTheme().primary },
									secondary: { main: handleTheme().secondary },
								},
								typography: { fontFamily: 'Roboto' },
							})}
						>
							<Routes auth={auth} />
						</MuiThemeProvider>
					</SnackbarProvider>
				</ErrorBoundary>
			</Container>
		</ThemeProvider>
	)
}

const mapStateToProps = state => ({
	auth: state.auth,
	i18n: state.i18nState,
	storeFS: state.fontSize.value,
})

const mapDispatchToProps = dispatch => ({
	logout: () => {
		dispatch(userLogout())
	},
	authRequest: () => {
		dispatch(userMe(false))
	},
	newTranslate: (obj, lng) => dispatch(setTranslations(obj, lng)),
	changeLanguage: lng => dispatch(setLanguage(lng)),
	setFontSize: size => dispatch(updateFontSize(size)),
	setDefault: size => dispatch(defaultFontSize(size)),
})

export default connect(mapStateToProps, mapDispatchToProps)(App)
